import { LineItem, OptionalLineItem } from '~/components/partials';
import {
  CompanyFeeSettingFragment,
  OrganizationCompanyFeeSettingFragment,
  OrganizationFeeSettingFragment,
  WebAppointmentForChargeFragment,
} from '~/graphql/generated/graphql';
import { SystemAmount } from '~/hooks/use-system_amount';

import { Fields } from './types';
import { useDefaultDelivery } from './use-default_delivery';

export const useCreateInitialValues = (
  appointment: WebAppointmentForChargeFragment | null,
  feeSettings: (
    | OrganizationFeeSettingFragment
    | CompanyFeeSettingFragment
    | OrganizationCompanyFeeSettingFragment
  )[],
  systemAmount: SystemAmount,
): Fields => {
  const defaultDelivery = useDefaultDelivery(appointment);
  const fixedSetting = feeSettings.find(({ fixed }) => fixed);
  const lineItem: LineItem = {
    code: fixedSetting?.code || 'billing_amount',
    subject: fixedSetting?.subject || '患者負担金',
    amount: systemAmount['medixs'] || fixedSetting?.defaultAmount || '',
  };
  const optionalLineItems: OptionalLineItem[] = feeSettings
    .filter((feeSetting) => feeSetting.defaultField && !feeSetting.fixed)
    .map((feeSetting) => ({
      feeSettingId: feeSetting.id,
      code: feeSetting.code,
      subject: feeSetting.subject,
      amount: feeSetting.defaultAmount || '',
    }));

  const disableAppPayment = !appointment?.appPayment && !appointment?.telemedicine;
  const paymentMethod = disableAppPayment ? 'cash' : 'app';

  return {
    paymentMethod: paymentMethod,
    lineItem,
    optionalLineItems,
    deliveryMethod: defaultDelivery,
    isNoAmount: false,
  };
};
